<template>
  <!-- self registration screen, link sent by email to register user information -->
  <div class="container-fluid py-5 background-login">
    <self-registration-confirm
      v-if="!showRegistrationForm"
      @showForm="setShowForm"
    ></self-registration-confirm>
    <div class="row" v-if="showRegistrationForm">
      <div class="col-sm-9 col-md-9 col-lg-8 mx-auto">
        <div class="card card-signin my-5 card-opacity">
          <div class="card-body">
            <button
              id="selfRegistrationBack"
              @click="backPage"
              style="
                cursor: pointer;
                background-color: transparent;
                border: none;
                margin-left: -10px;
                font-size: 18px;
              "
            >
              <em class="fa fa-chevron-left icon-chevron"></em>
            </button>
            <h4 class="card-title text-center" style="color: rgb(100, 95, 95)">
              Primeiro acesso
            </h4>
            <form
              class="form-signin"
              autocomplete="off"
              @submit.prevent="selfRegister"
            >
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for=" label-config">Beneficiário do Título </label>

                  <p class="title-align">
                    <span>{{ this.benSub | formatCPFCNPJ }}</span>
                    <span>{{ this.benName }}</span>
                  </p>
                  <hr />
                </div>
                <div class="form-group col-md-12">
                  <label for=" label-config">Sacado do Título </label>

                  <p class="title-align">
                    <span>{{ this.paySub | formatCPFCNPJ }}</span>
                    <span>{{ this.payName }}</span>
                  </p>
                  <hr />
                </div>

                <!-- <div class="form-group col-md-6">
                  <label for="registrationSelfRegistration label-config"
                    >CPF / CNPJ <span class="obrigatory-input">*</span>
                  </label>

                  <input
                    type="text"
                    id="registrationSelfRegistration"
                    class="form-control input-length"
                    v-bind:class="{ 'is-invalid': errors.registration }"
                    placeholder="Digite seu CPF ou CNPJ"
                    autocomplete="off"
                    v-mask="maskCPFCNPJ"
                    v-model="registNumber"
                    v-on:focus="setMaskCPFCNPJ"
                    required
                  />
                  <span v-if="errors.registration" class="error">
                    <ul>
                      <li v-for="msg in errors.registration">{{ msg }}</li>
                    </ul>
                  </span>
                </div> -->
                <div class="form-group col-md-6">
                  <div class="form-label-group">
                    <label for="nameSelfRegistration label-config"
                      >Nome <span class="obrigatory-input">*</span>
                    </label>

                    <input
                      type="text"
                      id="nameSelfRegistration"
                      class="form-control input-length"
                      v-bind:class="{ 'is-invalid': errors.name }"
                      placeholder="Digite seu nome"
                      autocomplete="off"
                      v-model="name"
                      required
                    />
                    <span v-if="errors.name" class="error">
                      <ul>
                        <li v-for="msg in errors.name">{{ msg }}</li>
                      </ul>
                    </span>
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <div class="form-label-group">
                    <label for="ddiSelfRegistration label-config">DDI</label>
                    <modal-celular-ddi-input
                      id="ddiSelfRegistration"
                      :value="celDdi"
                      @update:modelValue="(newValue) => (celDdi = newValue)"
                    />
                    
                    <span v-if="errors.ddi" class="error">
                      <ul>
                        <li :key="msg" v-for="msg in errors.ddi">{{ msg }}</li>
                      </ul>
                    </span>
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <div class="form-label-group">
                    <label for="celSelfRegistration label-config">Celular</label>
                    <input
                      type="text"
                      id="celSelfRegistration"
                      class="form-control input-length"
                      v-bind:class="{ 'is-invalid': errors.phone }"
                      placeholder="Digite seu Celular"
                      autocomplete="off"
                      v-mask="maskPhone"
                      v-model="celPhone"
                      v-on:focus="setMaskPhone"
                    />
                    <span v-if="errors.phone" class="error">
                      <ul>
                        <li v-for="msg in errors.phone">{{ msg }}</li>
                      </ul>
                    </span>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="emailSelfRegistration label-config"
                    >E-mail <span class="obrigatory-input">*</span>
                  </label>

                  <input
                    type="email"
                    id="emailSelfRegistration"
                    class="form-control input-length"
                    v-bind:class="{ 'is-invalid': errors.email }"
                    placeholder="Digite seu e-mail"
                    autocomplete="off"
                    v-model="email"
                    required
                  />
                  <span v-if="errors.email" class="error">
                    <ul>
                      <li v-for="msg in errors.email">{{ msg }}</li>
                    </ul>
                  </span>
                </div>
                <div class="form-group col-md-6">
                  <label for="userSelfRegistration label-config"
                    >Usuário <span class="obrigatory-input">*</span>
                  </label>

                  <input
                    type="text"
                    id="userSelfRegistration"
                    class="form-control input-length"
                    v-bind:class="{ 'is-invalid': errors.login }"
                    placeholder="Digite seu usuário"
                    autocomplete="off"
                    v-model="user"
                    required
                  />
                  <span v-if="errors.login" class="error">
                    <ul>
                      <li v-for="msg in errors.login">{{ msg }}</li>
                    </ul>
                  </span>
                </div>
                <div class="form-group col-md-6">
                  <label for="passwordSelfRegistration label-config"
                    >Senha <span class="obrigatory-input">*</span>
                  </label>

                  <input
                    type="password"
                    id="passwordSelfRegistration"
                    class="form-control input-length"
                    v-bind:class="{ 'is-invalid': errors.password }"
                    placeholder="Digite uma nova senha"
                    autocomplete="off"
                    v-model="password"
                    required
                  />
                  <span v-if="errors.password" class="error">
                    <ul>
                      <li v-for="msg in errors.password">{{ msg }}</li>
                    </ul>
                  </span>
                </div>
                <div
                  class="form-group col-md-6 margin-mobile"
                  :style="errors.password ? 'margin-top:-35px' : ''"
                >
                  <label for="confirmPasswordSelfRegistration label-config"
                    >Repetir senha <span class="obrigatory-input">*</span>
                  </label>

                  <input
                    type="password"
                    id="confirmPasswordSelfRegistration"
                    class="form-control input-length"
                    v-bind:class="{
                      'is-invalid': errors.password,
                    }"
                    placeholder=" Repita sua nova senha "
                    autocomplete="off"
                    v-model="confirmPassword"
                    required
                  />
                </div>
              </div>
              <label for="agreePolicySelfRegistration"
                ><input
                  id="agreePolicySelfRegistration"
                  type="checkbox"
                  value="agree"
                  v-model="checkedPolicyLink"
                />
                <span
                  >Eu li e aceito a
                  <a
                    data-toggle="modal"
                    id="PolicySelfRegistration"
                    data-target="#privacylinkmodal"
                  >
                    <span>Política de privacidade </span>
                  </a></span
                >
                <privacy-policy-link></privacy-policy-link>
              </label>

              <div class="access-center">
                <button
                  id="sendSelfRegistration"
                  class="btn btn-lg access-self"
                  :disabled="!checkedPolicyLink"
                  type="submit"
                >
                  Cadastrar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import PrivacyPolicyLink from "../../../common/components/PrivacyPolicyLink";
import SelfRegistrationConfirm from "./SelfRegistrationConfirm";
import ModalCelularDdiInput from "../../../common/components/ModalCelularDdiInput.vue";

export default {
  name: "Login",
  components: {
    PrivacyPolicyLink,
    SelfRegistrationConfirm,
    ModalCelularDdiInput
  },
  data() {
    return {
      checkedPolicyLink: false,
      logoImage: "",
      benName: "",
      payName: "",
      name: "",
      celDdi: "",
      celPhone: "",
      email: "",
      user: "",
      password: "",
      confirmPassword: "",
      errors: [],
      maskCPFCNPJ: "",
      maskPhone: "",
      groupId: "",
      showRegistrationForm: false,
      registNumber: "",
      paySub: "",
      benSub: "",
    };
  },

  methods: {
    selfRegister: function () {
      let data = {
        name: this.name,
        email: this.email,
        ddi: this.celDdi,
        phone: this.celPhone,
        login: this.user,
        password: this.password,
        password_confirmation: this.confirmPassword,
      };
      this.errors = [];
      axios
        .post(`${process.env.API_PBM}/user/firstAccess/${this.token}`, this.$qs.stringify(data))
        .then((response) => {
          let user = this.user;
          let password = this.password;
          let grp_id = response.data.data.grp_id;
          this.$store
            .dispatch("login", { user, password, grp_id })
            .then(() => {
              axios
                .post(`${process.env.API_PBM}/accept/privacyPolicy`, { product: "pp" })
                .then((responsePrivacy) => {
                  if (responsePrivacy.data.data) {
                    this.$router.push({ name: "home" });
                  }
                });
            })
            .catch(() => {
              this.$router.push({ path: `/${this.$route.query.group}` });
            });
        })
        .catch((error) => {
          this.errors = error.response.data.message;
        });
    },
    setMaskPhone: function () {
      this.maskPhone = ["#############"];
    },
    setShowForm: function () {
      this.showRegistrationForm = true;
    },
    setMaskCPFCNPJ: function () {
      this.maskCPFCNPJ = ["###.###.###-##", "##.###.###/####-##"];
    },
    backPage: function () {
      this.showRegistrationForm = false;
      this.name = "";
      this.celPhone = "";
      this.email = "";
      this.user = "";
      this.password = "";
      this.confirmPassword = "";
    },
  },

  mounted() {
    let group = this.$route.query.group;
    this.token = this.$route.query.token;

    axios
      .get(`${process.env.API_PBM}/group/${group}`)
      .then((response) => {
        let background = response.data.data.background;
        let logo = response.data.data.logo;
        if (background != null) {
          document.body.className = "background-login";
          document.body.style.backgroundImage = `url("${background}")`;
        }
        if (logo != null) {
          this.logoImage = logo;
        }
      });
    if (this.token) {
      axios
        .get(`${process.env.API_PBM}/user/firstAccess/${this.token}`)
        .then((response) => {
          this.benName = response.data.data.ced_nome;
          this.payName = response.data.data.pag_nome;
          // this.benSub = response.data.data.ced_inscricao;
          // this.paySub = response.data.data.pag_inscricao;
        })
        .catch((response) => {
          this.$router.push({ path: `urlExpired?group=${group}` });
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.background-login {
  height: 100%; /* Center and scale the image nicely */
  background-repeat: no-repeat center center fixed;
  background-size: cover;
}
.logo-image {
  width: 100%;
  max-width: 240px;
}

.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-top: 20px;
}

.obrigatory-input {
  color: #b0191a;
}

.title-align {
  margin-left: 35px;
  margin-right: 35px;
  font-size: 16px;
  color: rgb(100, 95, 95);
  text-align: justify;
}

.card-opacity {
  background: rgba(255, 255, 255, 0.9);
  border: none;
}

.input-length {
  margin: 0 auto;
  font-size: 15px;
}
.input-user {
  background: transparent;
  border: none;
  border-bottom: 1px solid #000000;
  outline: none;
  box-shadow: none;
}

.error {
  display: inline-block;
  font-size: 13px;
  color: #b0191a;
  margin-left: -22px;
}

label {
  display: inline-block;
  font-size: 17px;
  color: rgb(100, 95, 95);
}

.access-self {
  background-color: #b0191a;
  color: #fff;
  width: 20%;
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
}
.access-center {
  text-align: center;
}

a span {
  color: #b0191a;
  cursor: pointer;
  text-decoration: underline;
}

@media only screen and (max-width: 900px) {
  .access-self {
    background-color: #b0191a;
    color: #fff;
    width: 30%;
    margin-top: 15px;
    border-radius: 6px;
    cursor: pointer;
    padding: 5px;
    font-size: 17px;
  }
  .margin-mobile {
    margin-top: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/firstAccess/SelfRegistration.vue